import axios from './providers/axios';

const marketplaceCategoriesService = {
    getCategories(params = {}) {
        return axios.get(`/v1/admin/marketplace/categories/store`, { params });
    },
    getCategoryById(id) {
        return axios.get(`/v1/admin/marketplace/categories/getFromId/${id}`);
    }
}

export default marketplaceCategoriesService;
